import { render, staticRenderFns } from "./H5L.vue?vue&type=template&id=7960c7b4"
import script from "./H5L.vue?vue&type=script&lang=js"
export * from "./H5L.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports